var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "address-information-data" }, [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 px-0 address-type" },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-drop-down", {
                      attrs: {
                        clearable: false,
                        "custom-error-msg": _vm.validationMessages.select,
                        disabled: _vm.value.addressId != null,
                        error: errors[0],
                        fieldkey: "id",
                        fieldname: "name",
                        label: "Tipo de Dirección:",
                        options: _vm.availableAddressTypes,
                        placeholder: "Seleccione"
                      },
                      model: {
                        value: _vm.value.addressType,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "addressType", $$v)
                        },
                        expression: "value.addressType"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-sm-12 col-md-4 px-0 col-address" }, [
        _c(
          "div",
          { staticClass: "col-sm mb-3 data" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          error: errors[0],
                          label: "Dirección (Línea 1):"
                        },
                        model: {
                          value: _vm.value.addressLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "addressLine1", $$v)
                          },
                          expression: "value.addressLine1"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm mb-3 data" },
          [
            _c("custom-input", {
              attrs: { label: "Dirección (Línea 2):" },
              model: {
                value: _vm.value.addressLine2,
                callback: function($$v) {
                  _vm.$set(_vm.value, "addressLine2", $$v)
                },
                expression: "value.addressLine2"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm mb-3 data" },
          [
            _c("custom-input", {
              attrs: { label: "Dirección (Línea 3):" },
              model: {
                value: _vm.value.addressLine3,
                callback: function($$v) {
                  _vm.$set(_vm.value, "addressLine3", $$v)
                },
                expression: "value.addressLine3"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-sm-12 col-md-8 px-0" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-1" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-drop-down", {
                        attrs: {
                          "custom-error-msg": _vm.validationMessages.select,
                          error: errors[0],
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Municipio:",
                          options: _vm.municipalities,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.value.municipality,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "municipality", $$v)
                          },
                          expression: "value.municipality"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-2" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          error: errors[0],
                          label: "Código Postal:",
                          "mask-type": "ZipcodeExt",
                          placeholder: "_____-____"
                        },
                        model: {
                          value: _vm.value.zipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "zipCode", $$v)
                          },
                          expression: "value.zipCode"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c("div", { staticClass: "clearfix" }),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-1" },
          [
            _c("validation-provider", {
              attrs: { rules: { regex: /(-?\d+(\.\d+)?)/ } },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg":
                            _vm.validationMessages.invalidCoordinate,
                          error: errors[0],
                          label: "Latitud:",
                          placeholder: "____._________"
                        },
                        model: {
                          value: _vm.value.gpsLatitude,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "gpsLatitude", $$v)
                          },
                          expression: "value.gpsLatitude"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-2" },
          [
            _c("validation-provider", {
              attrs: { rules: { regex: /(-?\d+(\.\d+)?)/ } },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg":
                            _vm.validationMessages.invalidCoordinate,
                          error: errors[0],
                          label: "Longitud:",
                          placeholder: "____._________"
                        },
                        model: {
                          value: _vm.value.gpsLongitude,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "gpsLongitude", $$v)
                          },
                          expression: "value.gpsLongitude"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 mb-3 fl col-metadata-1 pr-0" },
          [
            _c("custom-input", {
              attrs: {
                label: "Anotaciones Adicionales:",
                placeholder: "Escribir información adicional de cómo llegar…"
              },
              model: {
                value: _vm.value.addressDescription,
                callback: function($$v) {
                  _vm.$set(_vm.value, "addressDescription", $$v)
                },
                expression: "value.addressDescription"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }